export * from './svg-sprite-def/svg-sprite-def.component';
export * from './svg-icon/svg-icon.component';
export * from './svg-sprite.module';
